
import { defineComponent, onMounted, ref } from "vue";
import useState from "@/store";
import usePlugin from "@/plugins";
import {
  GetServicePartnerResponse,
  ServicePartner,
  UpsertServicePartnerRequest,
  UpsertServicePartnerResponse,
} from "@/types";
import { clone } from "ramda";
import { useVuelidate } from "@vuelidate/core";
import { required, url } from "@vuelidate/validators";
import { useClipboard } from "@vueuse/core";

export default defineComponent({
  name: "ConfigServiceScreen",
  setup() {
    const init: ServicePartner = {
      id: 0,
      name: "",
      messagePrefix: "",
      receivedMessageEndpoint: "",
      jwtToken: "",
      createOn: null,
      createBy: null,
      updateOn: null,
      updateBy: null,
    };
    const showNewDialog = ref(false);
    const state = useState();
    const { axios, success, error } = usePlugin();
    const services = ref<ServicePartner[]>([]);
    const service = ref<ServicePartner>(clone(init));

    const onNew = () => {
      service.value = clone(init);
      showNewDialog.value = true;
    };

    const loadDocument = async () => {
      state.value.isLoading = true;
      try {
        const result = await axios.post<GetServicePartnerResponse>(
          "api/v1/server/servicePartner/get",
          {}
        );
        services.value = result.data.servicePartners ?? [];
        success("ดึงข้อมูลสำเร็จ");
      } catch (e) {
        error(e);
      } finally {
        state.value.isLoading = false;
      }
    };

    const onSubmit = async (regenToken = false) => {
      v$.value.$reset();
      v$.value.$touch();
      if (!(await v$.value.$validate())) return;

      state.value.isLoading = true;
      try {
        const result = await axios.post<UpsertServicePartnerResponse>(
          "api/v1/server/servicePartner/upsert",
          {
            servicePartner: service.value,
            regenerateToken: regenToken,
          } as UpsertServicePartnerRequest
        );
        success("บันทึกข้อมูลแล้ว");
        showNewDialog.value = false;
        await loadDocument();
      } catch (e) {
        error(e);
      } finally {
        state.value.isLoading = false;
      }
    };

    const onRegenerateToken = async () => {
      await onSubmit(true);
    };

    const onCancel = () => {
      showNewDialog.value = false;
    };
    const onEdit = (data: ServicePartner) => {
      service.value = clone(data);
      showNewDialog.value = true;
    };

    const clipboard = useClipboard();
    const copyToken = (token: string) => {
      clipboard.copy(token);
      success("Token copied !!!");
    };

    const rules = {
      service: {
        name: { required },
        messagePrefix: { required },
        receivedMessageEndpoint: { required, url },
      },
    };

    const v$ = useVuelidate(rules, { service });

    onMounted(() => loadDocument());
    return {
      showNewDialog,
      onNew,
      onCancel,
      services,
      service,
      onSubmit,
      onEdit,
      v$,
      copyToken,
      onRegenerateToken,
    };
  },
});
